export const LINK_QRCODE = 'http://marou.traceverified.com/trace?doc=';

export const ImageType = 'data:image/jpeg;base64,';

export const Local = {
    TOKEN: 'Token',
    User: 'User',
    FullName: 'FullName',
    UserName: 'UserName',
    Permission: 'Permission',
};
export const Gender = [
    {name: 'Nam' },
    {name: 'Nữ' },
];

export const FarmModelOptions = [
    {id: 1,  name: 'Đơn canh' },
    {id: 2,  name: 'Đa canh' },
    {id: 3,  name: 'Nông lâm kết hợp' },
    {id: 4,  name: 'Naturland' },
    {id: 5,  name: 'USDA' },
    {id: 6,  name: 'EU' },
    {id: 7,  name: 'Khác' },
];

export const FarmerTypes =  [
    { id: 1, name: 'Nông dân Marou' },
    { id: 2, name: 'Nông dân bán trái' },
    { id: 3, name: 'Dự án cây giống' },
];

export const Action = {
    Create: 'Create',
    Back: 'Back',
    Edit: 'Edit',
    Delete: 'Delete',
    View: 'View',
    Translate: 'Translate',
    Qrcode: 'Qrcode',
    Filter: 'Filter',
    Copy: 'Copy',
    PrintQrcode: 'PrintQrcode',
    PageChange: 'PageChange',
    Delivery: 'Delivery',
};

export const RoleRight = [
    { Id: 1, Action: 'View', Name: 'Xem' },
    { Id: 2, Action: 'Create', Name: 'Tạo mới' },
    { Id: 3, Action: 'Edit', Name: 'Cập nhật' },
    { Id: 4, Action: 'Qrcode', Name: 'Qrcode' },
    { Id: 5, Action: 'Filter', Name: 'Filter' },
    { Id: 6, Action: 'Translate', Name: 'Translate' },
    { Id: 7, Action: 'Delete', Name: 'Delete' },
    { Id: 8, Action: 'Copy', Name: 'Copy' },
    { Id: 9, Action: 'PrintQrcode', Name: 'Xuất tem in qrcode' },
];

export const Lang = [
    { Id: '1', Code: 'vi', Name: 'Việt Nam', Default: true },
    { Id: '2', Code: 'en', Name: 'English', Default: false },
];

export const Pagination = {
    PageSize: 50,
    PageIndex: 1,
};

export const StatusCode = {
    Status200OK: '200',
    Status201Created: '201',
    Status202Accepted: '202',
    Status500InternalServerError: '500',
    Status401Unauthorized: '401',
};

export const MemberTypes = {
    Member: 2,
    Technical: 6,
    NoneMember: 7,
    Seller: 8,
    Association: 10,
};

export const Types = {
    Date: 'Date',
    Time: 'Time',
    Number: 'Number',
    Double: 'Double',
};

export const StatusVerifiedCode = {
    UnCheck: 0,
    Checked: 1,
    Fail: 2,
};

export const Flavour = [
    { Id: 'Spicy', Name: 'Spicy' },
    { Id: 'Fruity', Name: 'Fruity' },
    { Id: 'Nutty', Name: 'Nutty' },
    { Id: 'Earthy', Name: 'Earthy' },
    { Id: 'Green', Name: 'Green' },
    { Id: 'FreshHer', Name: 'Fresh Herb' },
    { Id: 'DriedHerb', Name: 'Dried Herb' },
    { Id: 'Dairy', Name: 'Dairy' },
    { Id: 'DriedFruit', Name: 'Dried Fruit' },
    { Id: 'Floral', Name: 'Floral' },
    { Id: 'Choco', Name: 'Choco' }
];

export const RatingStatus = [
    { Id: 'SD', Name: 'Standard bean (SD)' },
    { Id: 'BL', Name: 'Below (BL)' },
    { Id: 'N', Name: 'No (N)' },
    { Id: 'R', Name: 'Reject (R)' },
    { Id: 'X', Name: 'Missing (X)' },
    { Id: 'RECUT', Name: 'RECUT' },
];
export const QuestionType = [
    { Id: 1, Name: 'Chọn một' },
    { Id: 2, Name: 'Chọn nhiều' },
    { Id: 3, Name: 'Chọn hoặc nhập text' },
    { Id: 4, Name: 'Nhập text' },
    { Id: 5, Name: 'Ngày tháng năm' },
];
export const RatingResult = [
    { Id: 'AA', Name: 'AA' },
    { Id: 'A', Name: 'A' },
    { Id: 'B', Name: 'B' },
    { Id: 'BL', Name: 'BL' },
    { Id: 'N', Name: 'N' },
    { Id: 'X', Name: 'X' },
];

export const ShippingStatus = [
    { Id: 'WAITING', Name: 'Chờ vận chuyển' },
    { Id: 'SHIPPING', Name: 'Đang vận chuyển' },
    { Id: 'DELIVERED', Name: 'Hoàn thành' },
];
export const ShippingStatusV2 = [
    { Id: 'ALL', Name: 'Tất cả' },
    { Id: 'WAITING', Name: 'Chờ vận chuyển' },
    { Id: 'SHIPPING', Name: 'Đang vận chuyển' },
    { Id: 'DELIVERED', Name: 'Hoàn thành' },
];
export const ContractStatus = [
    { Id: 'ALL', Name: 'Tất cả' },
    { Id: 'Signed', Name: 'Đã ký' },
    { Id: 'unsigned', Name: 'Chưa ký' },
];

export const ContractStatusV2 = [
    { Id: -1, Name: 'Tất cả' },
    { Id: 1, Name: 'Đã ký' },
    { Id: 0, Name: 'Chưa ký' },
];
export const ProcessType = [
    { id: '1', name: 'Marketing' },
    { id: '2', name: 'Công việc' },
];

export const ProductStatus = [
    { id: 'PROCESSING', name: 'Đang thực hiện' },
    { id: 'DONE', name: 'Hoàn tất' },
];

export const FertilizerMedicineType = [
    { id: 1, name: 'Phân hữu cơ' },
    { id: 2, name: 'Phân hoá học' },
    { id: 3, name: 'Thuốc bảo vệ thực vật' },
    { id: 4, name: 'Vôi' },
];

export const EffectiveUseOfFertilizers = [
    {
        id: '1',
        pH: '4.5-4.9',
        effectiveN: 30,
        effectiveP2o5: 23,
        effectiveK2o: 33,
        limeName: 'Vôi Dolomite',
        limeWeight: '1300',
        type: '2'
    },
    {
        id: '2',
        pH: '5.0-5.4',
        effectiveN: 53,
        effectiveP2o5: 34,
        effectiveK2o: 52,
        limeName: 'Vôi Dolomite',
        limeWeight: '1000',
        type: '2'
    },
    {
        id: '3',
        pH: '5.5-5.9',
        effectiveN: 77,
        effectiveP2o5: 46,
        effectiveK2o: 77,
        limeName: 'Vôi Dolomite',
        limeWeight: '800',
        type: '2'
    },
    {
        id: '4',
        pH: '6.0-6.4',
        effectiveN: 89,
        effectiveP2o5: 52,
        effectiveK2o: 100,
        limeName: 'Vôi Dolomite',
        limeWeight: '500',
        type: '2'
    },
    {
        id: '5',
        pH: '6.5',
        effectiveN: 100,
        effectiveP2o5: 100,
        effectiveK2o: 100,
        limeName: 'Vôi Dolomite',
        limeWeight: '0',
        type: '2'
    },
    {
        id: '6',
        pH: '',
        effectiveN: '50',
        effectiveP2o5: '50',
        effectiveK2o: '50',
        limeName: '',
        limeWeight: '',
        type: '1'
    },
];

export const NutritionalRequirements = [
    { id: '1', year: '1' , expectedProductivity: '', N: '16.1', P2O5: '12', K2O: '9'},
    { id: '2', year: '2' , expectedProductivity: '', N: '69', P2O5: '48', K2O: '30'},
    { id: '3', year: '3' , expectedProductivity: '', N: '92', P2O5: '72', K2O: '60'},
    { id: '4', year: '4' , expectedProductivity: '', N: '46', P2O5: '32', K2O: '120'},
    { id: '5', year: '5' , expectedProductivity: '', N: '69', P2O5: '48', K2O: '180'},
    { id: '6', year: '6 trở đi' , expectedProductivity: '', N: '92', P2O5: '64', K2O: '240'},
    ];

export const StatusVerified = {
    BLBasicTasteList : [
        'BL|BL|BL',
        'BL|BL|B',
        'BL|BL|A',
        'BL|BL|AA',
        'BL|B|BL',
        'BL|B|B',
        'BL|B|A',
        'BL|B|AA',
        'BL|A|BL',
        'BL|A|B',
        'BL|A|A',
        'BL|A|AA',
        'BL|AA|BL',
        'BL|AA|B',
        'BL|AA|A',
        'BL|AA|AA',
        'B|BL|BL',
        'B|BL|B',
        'B|BL|A',
        'B|BL|AA',
        'B|B|BL',
        'A|BL|BL',
        'A|BL|B',
        'A|BL|A',
        'A|BL|AA',
        'A|B|BL',
        'AA|BL|BL',
        'AA|BL|B',
        'AA|BL|A',
        'AA|BL|AA',
    ],
    BBasicTasteList : [
        'B|B|B',
        'B|B|A',
        'B|B|AA',
        'B|A|BL',
        'B|A|B',
        'B|A|A',
        'B|A|AA',
        'B|AA|BL',
        'B|AA|B',
        'B|AA|A',
        'B|AA|AA',
        'A|B|B',
        'A|B|A',
        'A|B|AA',
        'A|A|BL',
        'A|A|B',
        'A|AA|BL',
        'AA|B|BL',
        'AA|B|B',
        'AA|B|A',
        'AA|B|AA',
        'AA|A|BL',
        'AA|A|B',
        'AA|AA|BL',
    ],
    ABasicTasteList : [
        'A|A|A',
        'A|A|AA',
        'A|AA|B',
        'A|AA|A',
        'A|AA|AA',
        'AA|A|A',
        'AA|A|AA',
        'AA|AA|B',
    ],
    AABasicTasteList: ['AA|AA|AA', 'AA|AA|A'],
    BLBeanQualityList : [
        'BL|BL|BL',
        'BL|BL|B',
        'BL|BL|A',
        'BL|BL|AA',
        'BL|B|BL',
        'BL|B|B',
        'BL|B|A',
        'BL|B|AA',
        'BL|A|BL',
        'BL|A|B',
        'BL|A|A',
        'BL|A|AA',
        'BL|AA|BL',
        'BL|AA|B',
        'BL|AA|A',
        'BL|AA|AA',
        'B|BL|BL',
        'B|BL|B',
        'B|BL|A',
        'B|BL|AA',
        'B|B|BL',
        'B|A|BL',
        'B|AA|BL',
        'A|BL|BL',
        'A|BL|B',
        'A|BL|A',
        'A|BL|AA',
        'A|B|BL',
        'A|A|BL',
        'A|AA|BL',
        'AA|BL|BL',
        'AA|BL|B',
        'AA|BL|A',
        'AA|BL|AA',
        'AA|B|BL',
        'AA|A|BL',
        'AA|AA|BL',
    ],
    BBeanQualityList : [
        'B|B|B',
        'B|B|A',
        'B|B|AA',
        'B|A|B',
        'B|AA|B',
        'A|B|B',
        'A|B|A',
        'A|B|AA',
        'A|A|B',
        'A|AA|B',
        'AA|B|B',
        'AA|B|A',
        'AA|B|AA',
        'AA|A|B',
        'AA|AA|B',
    ],
    ABeanQualityList : [
        'B|A|A',
        'B|A|AA',
        'B|AA|A',
        'B|AA|A',
        'A|A|A',
        'A|A|AA',
        'A|AA|A',
        'AA|A|A',
        ,
    ],
    AABeanQualityList : ['A|AA|AA', 'AA|A|AA', 'AA|AA|A', 'AA|AA|AA'],
};

